import React, { useEffect, useState } from 'react';
import StableMuiDialog from '../../common/StableMuiDialog.js';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { formatDateWithoutTimezone } from '../../common/dateUtils';

const formatSalePrice = (value) => {
  if (value == null || value === '') return '—';
  const n = Number(value);
  if (!Number.isFinite(n)) return String(value);
  return n.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
};

const alFlagLabel = (flag) => {
  if (flag === 0 || flag === '0') return 'NAL (0)';
  if (flag === 1 || flag === '1') return 'AL (1)';
  if (flag == null || flag === '') return '—';
  return String(flag);
};

/**
 * Modal to pick among multiple inventory sales for the same parcel.
 */
export default function SelectInventorySaleDialog({ open, rows = [], onSelect, onCancel }) {
  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    if (open) setSelectedIndex(0);
  }, [open, rows]);

  const handleClose = () => {
    onCancel?.();
  };

  const handleConfirm = () => {
    onSelect?.(rows[selectedIndex] ?? null);
  };

  return (
    <StableMuiDialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Select Sale</DialogTitle>
      <DialogContent>
        <p className="text-sm text-gray-600 mb-3">
          Multiple sales were found for this parcel. Choose which sale to use as the comparable.
        </p>
        <div className="flex flex-col gap-2">
          {rows.map((row, index) => {
            const selected = index === selectedIndex;
            return (
              <button
                key={`${row.TransactionID ?? row.parcel_id}-${index}`}
                type="button"
                onClick={() => setSelectedIndex(index)}
                className={`text-left w-full rounded border px-3 py-2 transition-colors ${
                  selected
                    ? 'border-blue-600 bg-blue-50 ring-1 ring-blue-600'
                    : 'border-gray-300 hover:border-gray-400 bg-white'
                }`}
              >
                <div className="text-sm font-medium">
                  Sale Price: {formatSalePrice(row.SalePrice)}
                </div>
                <div className="text-sm text-gray-700">
                  Sale Date: {formatDateWithoutTimezone(row.SaleDate)}
                </div>
                <div className="text-sm text-gray-700">
                  AL Flag: {alFlagLabel(row.ALFlag)}
                </div>
                <div className="text-sm text-gray-700">
                  MLS Number: {row.MLSNumber != null && row.MLSNumber !== '' ? row.MLSNumber : '—'}
                </div>
                <div className="text-sm text-gray-700">
                  Transaction ID: {row.TransactionID != null && row.TransactionID !== '' ? row.TransactionID : '—'}
                </div>
              </button>
            );
          })}
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleConfirm} variant="contained" color="primary" disabled={!rows.length}>
          Use Selected Sale
        </Button>
      </DialogActions>
    </StableMuiDialog>
  );
}
